<div class="fixed-bottom d-flex justify-content-center mb-md z-index-top">
    <div class="alert alert-primary text-center p-4 font-weight-bold">
        <i style="padding-top:2px" class="fad fa-spinner fa-spin mr-2"></i>Loading data. This can take a few seconds for larger data sets.
    </div>
</div>
